module.exports = __webpack_public_path__ + "static/img/bot-step-4.1d17a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bot-step-4.png
// module id = jmxH
// module chunks = 11